import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import { formatPatternTitle } from '../utils';

interface PatternRelationshipsProps {
  requires: string[];
  enhances: string[];
}

export function PatternRelationships({
  enhances,
  requires,
}: PatternRelationshipsProps): JSX.Element | null {
  if (requires.length === 0 && enhances.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 border-t border-default pt-6 space-y-4">
      {requires.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-muted uppercase tracking-wide mb-2">
            Required Patterns
          </h3>
          <div className="flex flex-wrap gap-2">
            {requires.map(id => (
              <Link
                key={id}
                to={`/patterns/${id}`}
                className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg bg-surface-elevated hover:bg-primary/10 border border-default transition-colors"
              >
                <ArrowRightIcon className="h-3 w-3" />
                {formatPatternTitle(id)}
              </Link>
            ))}
          </div>
        </div>
      )}
      {enhances.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-muted uppercase tracking-wide mb-2">
            Enhances
          </h3>
          <div className="flex flex-wrap gap-2">
            {enhances.map(id => (
              <Link
                key={id}
                to={`/patterns/${id}`}
                className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg bg-surface-elevated hover:bg-primary/10 border border-default transition-colors"
              >
                <ArrowRightIcon className="h-3 w-3" />
                {formatPatternTitle(id)}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
